import { variables } from '../variables';
import AvenirNextBold from '../../fonts/HardAssetsAlliance/AvenirNext-Bold.woff2';
import AvenirNextDemiBold from '../../fonts/HardAssetsAlliance/AvenirNext-DemiBold.woff2';
import AvenirNextMedium from '../../fonts/HardAssetsAlliance/AvenirNext-Medium.woff2';
import AvenirNextRegular from '../../fonts/HardAssetsAlliance/AvenirNext-Regular.woff2';

export const gbiDirectColors = {
  colorPrimary: '#3343A3',
  colorPrimaryLight: '#FAFBFC',
  colorPrimaryDark: '#253176',
  colorWhite: '#ffffff',
  colorBlack: '#000000',
  colorRed: '#B73030',
  colorGrey: '#EEEEEE',

  // Backgrounds
  colorBackgroundPrimary: '#ffffff',
  colorBackgroundSecondary: '#F8F9FA',
  colorWarningnBackground: '#FFE8E8',
  colorBackgroundTableRowContainer: '#FCF1D9',

  // Typography Colors
  // Text
  colorTextPrimary: '#0B0E1A',
  colorTextSecondary: '#505575',
  colorDisabledIcon: '#ADB1C7',
  colorTextContrast: '#ffffff',
  colorTextHeader: '#ffffff',
  colorTextLink: '#EBA000',
  colorTextGold: '#EBA000',

  colorBrandLight: '#FDB913',

  colorSuccess: '#008C5B',
  colorPayoutSuccess: '#33BB5D',
  colorBadgeSuccess: 'rgba(51, 187, 93, 0.20)',
  colorError: '#B73030',
  colorWarning: '#EBA000',
  colorPreAuthOrange: '#DD851C',
  colorWarningBackground: 'rgba(237, 179, 38, 0.05)',
  // Insufficient-balance callouts (e.g. the GTT order-entry shortfall line).
  colorBalanceLow: '#F39D36',
  // Total Balance card segmented progress bar (Financial Balances page).
  colorBalanceAvailable: '#2BAB58',
  colorBalanceReserved: '#FF9E42',
  colorShadowCard: '#0000002E',
  colorIconBackground: '#f9f9f9',
  colorMismatchValidBackground: 'rgba(51, 187, 93, 0.02)',
  colorMismatchValidBorder: 'rgba(51, 187, 93, 1)',
  colorMismatchErrorBackground: 'rgba(179, 38, 30, 0.02)',
  colorMismatchErrorBorder: 'rgba(179, 38, 30, 0.3)',
  colorIncomplete: '#333333',

  // Links
  colorLinkPrimary: '#3343A3',
  colorLinkRegistration: '#3343A3', // semiDark'

  // Button Colors
  colorButtonPrimary: '#3343A3',
  colorButtonPrimaryText: '#ffffff',
  colorButtonPrimaryHover: '#3E51C4',
  colorButtonPrimaryFocused: '#253176',
  colorButtonPrimaryHoverText: '#ffffff',
  colorButtonPrimaryDisabled: '#ADB1C7',
  colorButtonOutlined: '#ffffff',
  colorButtonOutlinedBorder: '#3343A3',
  colorButtonOutlinedText: '#3343A3',
  colorButtonDisabled: '#E9EDFA',

  colorButtonDefault: '#ffffff',
  colorButtonDefaultText: '#3343A3',
  colorButtonDefaultBorder: '#3343A3',
  colorButtonDefaultHover: '#E9EDFA',
  colorButtonAddNewBank: '#ffffff',

  // Input
  colorInputBorder: 'rgba(51,51,51,0.3)',
  colorInputBackground: '#ffffff',
  colorInputBackgroundDisabled: '#EEEEEE',
  colorInputBorderFocused: '#3343A3',
  colorInputBorderActive: '#3343A3',
  colorInputText: '#0B0E1A',
  colorInputPlaceholder: '#333333',
  colorInputSelectItemFocused: '#E9EDFA',

  // Label
  colorLabel: '#333333',

  // Modal
  colorModalBackground: 'rgba(51,51,51,0.3)',

  // Tabs
  colorTabBackground: '#ffffff',
  colorTabText: '#3343A3',
  colorTabSelectedBackground: '#3343A3',
  colorTabSelectedText: '#ffffff',

  // Pills
  colorPillsBackground: '#E9EDFA',
  colorPillsText: '#3343A3',
  colorPillsBackgroundActive: '#3343A3',
  colorPillsTextActive: '#ffffff',

  // Filters
  colorFilterItemBackground: '#3343A3',
  colorFilterItemText: '#ffffff',
  colorFilterIcon: '#ffffff',

  // Icons
  colorIconPrimary: '#3343A3',
  colorIconSecondary: '#333333',
  colorLoaderIcon: '#3343A3',

  // Radio Button
  colorRadioButton: '#333333',
  colorRadioButtonWrapperBorderSelected: '#3343A3',

  // Tooltip
  colorTooltipBackground: '#0B0E1A',
  colorTooltipText: '#ffffff',

  // Password Strength
  colorPasswordStrengthDefault: '#EEEEEE',
  colorPasswordStrengthWeak: '#B73030',
  colorPasswordStrengthAverage: '#EBA000',
  colorPasswordStrengthGood: 'rgba(0,140,91,0.6)',
  colorPasswordStrengthStrong: '#008C5B',

  // Progress Bar Colors, Linear Gradient
  colorLinearGradientStart: '#E9EDFA',
  colorLinearGradientEnd: '#253176',
  colorProgressBarDefault: '#EEEEEE',
  colorProgressBarFilled: '#3343A3',

  // Header Colors
  colorMainHeaderBackground: '#EEEEEE',
  colorSecondaryHeaderBackground: '#ffffff',
  colorHeaderLogoLight: '#ffffff',
  colorHeaderLogoDark: '#0B0E1A',

  // Navigation Colors
  colorNavigationItemHover: '#EEEEEE',

  // Navigation Dropdown Color
  colorNavigationDropdownBackground: '#333333',
  colorNavigationDropdownItemHoverBackground: 'rgba(37, 49, 118, 0.5)',

  // Account Colors
  colorAccountBackground: '#000000',
  colorAccountBorder: '#EEEEEE',

  // Footer Colors
  colorFooterBackground: '#0B0E1A',
  colorFooterText: '#FFFFFF',

  // Horizontal Break and Borders, Separators
  colorBorderPrimary: '#E9EDFA',
  colorBorderSecondary: '#3343A3',

  // Table Colors
  colorTableHeaderBackground: 'rgba(51,51,51,0.15)',
  colorTableEvenRowBackground: '#EEEEEE',
  colorTableEvenRowHoverBackground: '#f4f4f4',
  colorTableSelectedBackground: '#f4f4f4',
  colorHeadingRowItem: 'rgba(51,51,51,0.15)',

  // Shippment Status Colors
  colorShippmentSuccess: '#008C5B',
  colorShippmentPending: '#C78802',
  colorShippmentShipped: '#3343A3',
  colorShippmentFailed: '#B73030',

  // Address Status Colors
  colorVerifiedSuccess: '#008C5B',
  colorNotVerified: 'rgba(51,51,51,0.5)',

  // Card Colors
  colorCardBackground: '#ffffff',
  colorCardSelected: '#E9EDFA',
  colorCardBorder: '#EFF6FC',

  // Scrollbar Colors
  colorScrollbarBackground: 'rgba(51,51,51,0.3)',

  // MakeOver Banner
  colorInputBg: '#F5F5F5',
  colorCheckboxBorder: '#818181',
  colorMakeOverBannerBackground: '#EEEEEE',
  colorMakeOverBanner: '#0B0E1A',

  // Pending Banner
  colorPendingBannerBackground: '#FCF1D9',

  // Onboarding
  colorOnboardingBoxBorder: '#EEEEEE',
  colorOnboardingBoxBackground: '#EEEEEE',
  colorOnboardingTextPrimary: '#ffffff',

  // Empty Box
  colorEmptyBoxTextPrimary: 'rgba(51,51,51,0.3)',

  // Graphic
  colorGraphicGridLines: '#EEEEEE',

  // Info Banner
  colorInfoBannerBackground: '#0b0e1a',
  colorInfoBannerBackground2: '#364580',
  colorInfoBannerText: '#ffffff',

  // Auth card
  colorAuthCardSubtitle: '#0B0E1A',

  // Registration
  colorRegistration: '#333333',

  // Graph line
  colorGraphLine: '#3343A3',

  // Tags
  colorTag: '#3343A3',

  // Filters
  colorFilter: '#3343A3',

  // Add Button
  colorAddButton: '#3343A3',

  // Focus color
  colorFocus: '#3343A3',

  // Flag color
  colorFlag: '#3343A3',

  // Note background
  colorNoteBackground: '#E9EDFA',

  // Price tiers rows
  colorRowBgOne: '#F9FAFB',
  colorRowBgTwo: '#EFF6FF',
  colorRowBrTwo: '#D8E8FD',
  colorRowBgThree: '#FEF8EB',
  colorRowBrThree: '#F8DB9C',
  colorRowBgFour: '#F0FDF4',
  colorRowBrFour: '#CAFBD9',
  colorBestFlag: '#33BB5D',

  // Sell From Home Banner color
  colorBannerBg: '#EEF4FD',
};

export const hardAssetsAllianceFonts = `
@font-face {
  font-family: "Segoe UI", ${variables.family.hardAssetsAlliance},sans-serif;
  src: url(${AvenirNextBold}) format('woff2');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Segoe UI", ${variables.family.hardAssetsAlliance},sans-serif;
  src: url(${AvenirNextDemiBold}) format('woff2');
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Segoe UI", ${variables.family.hardAssetsAlliance}, sans-serif;
  src: url(${AvenirNextMedium}) format('woff2');
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Segoe UI", ${variables.family.hardAssetsAlliance},sans-serif;
  src: url(${AvenirNextRegular}) format('woff2');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

*,
*::after,
*::before {
  font-family: "Segoe UI", ${variables.family.hardAssetsAlliance}, sans-serif;
}
`;
